var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sidebar-item',{attrs:{"text":"Gerar listas e gabaritos","to":{ name: _vm.HOME_ROUTE_NAME }},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('use',{attrs:{"xlink:href":"#icon-paper"}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }